<template>
  <Toast v-show="showToast" :type="type">
    <i :class="!toastSuccess ? 'weui_icon_warn':'weui_icon_success'" v-if="type ==='icon'"></i>
    {{toastMessage}}
  </Toast>
</template>
<script>
import Toast from 'vue-weui/components/toast/toast.vue'

export default {
  name: 'HkjNotice',
  components: {
    Toast
  },
  data() {
    return {
      showToast: false,
      toastSuccess: false,
      type: 'text',
      toastMessage: '提示消息'
    }
  },
  methods: {
    // 显示toast
    show(opt) {
      this.showToast = true
      this.toastSuccess = opt.toastSuccess
      this.type = opt.type || 'text'
      this.toastMessage = opt.toastMessage
      
      setTimeout(() => {
        this.showToast = false
      }, opt.duration || 3000)
    }
  }
}
</script>